export default __webpack_public_path__ + "static/hero-module2x-adbb568927b900b93484de94feb3e5d6.webp";